import { Link } from "react-router-dom";
import { LABEL, GUIDES } from "../data.js";

export default function Footer({ go }) {
  return (
    <footer>
      <div className="ftin">
        <div className="ftt">
          {/* Brand */}
          <div>
            <Link to="/" className="flt" aria-label="NoleggioinCloud" style={{ textDecoration:"none", cursor:"pointer", display:"inline-flex", alignItems:"center", fontSize:"1.5rem", letterSpacing:"-.01em" }}>
              Noleggio<span className="flt-in">in</span>Cloud
            </Link>
            <p className="ftag">
              Gestionale cloud per autonoleggi e motonoleggi italiani.
              Sito prenotazioni, pagamenti Stripe e contratti PDF inclusi.
            </p>
          </div>

          {/* Prodotto */}
          <div>
            <div className="fh">Prodotto</div>
            <ul className="flks">
              {["funzionalita","come-funziona","prezzi","tutorial"].map(p => (
                <li key={p}>
                  <Link to={`/${p}`} style={{ textDecoration:"none" }}>{LABEL[p]}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Guide */}
          <div>
            <div className="fh">Guide</div>
            <ul className="flks">
              {GUIDES.map(g => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`} style={{ textDecoration:"none" }}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Azienda */}
          <div>
            <div className="fh">Azienda</div>
            <ul className="flks">
              <li><Link to="/chi-siamo" style={{ textDecoration:"none" }}>Chi siamo</Link></li>
              <li><Link to="/faq"      style={{ textDecoration:"none" }}>FAQ</Link></li>
              <li><Link to="/contatti" style={{ textDecoration:"none" }}>Contatti</Link></li>
              <li><Link to="/prezzi"   style={{ textDecoration:"none" }}>Prova gratis</Link></li>
              <li><a href="https://www.instagram.com/noleggioincloud.app/" target="_blank" rel="noopener noreferrer me" style={{ textDecoration:"none" }}>Instagram</a></li>
            </ul>
          </div>
        </div>

        <div className="ftb">
          <div className="fcp">
            © {new Date().getFullYear()} NoleggioinCloud — Tutti i diritti riservati
          </div>
          <div className="fcp">
            Gestionale cloud per autonoleggi e motonoleggi italiani
          </div>
        </div>

        {/* Credit */}
        <div style={{ textAlign:"center", marginTop:"1.25rem", paddingTop:"1.25rem", borderTop:"1px solid rgba(255,255,255,.06)", fontSize:".75rem", color:"rgba(255,255,255,.28)" }}>
          Sito realizzato da{" "}
          <a href="https://www.giuseppesavarese.it" target="_blank" rel="noopener noreferrer"
            style={{ color:"rgba(255,255,255,.55)", textDecoration:"none", fontWeight:600 }}
            onMouseEnter={e => e.currentTarget.style.color="#fff"}
            onMouseLeave={e => e.currentTarget.style.color="rgba(255,255,255,.55)"}
          >
            Giuseppe Savarese
          </a>
        </div>
      </div>
    </footer>
  );
}
